var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/ugc-filters.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = (lineno = 0, colno = 19, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["ugc.config.filters"]));
frame.set("filters", t_1, true);
if(frame.topLevel) {
context.setVariable("filters", t_1);
}
if(frame.topLevel) {
context.addExport("filters", t_1);
}
output += "\n";
var t_2;
t_2 = (lineno = 1, colno = 24, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["ugc.activeFilter"]));
frame.set("activeFilter", t_2, true);
if(frame.topLevel) {
context.setVariable("activeFilter", t_2);
}
if(frame.topLevel) {
context.addExport("activeFilter", t_2);
}
output += "\n\n";
if(runtime.contextOrFrameLookup(context, frame, "filters") && env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "filters")) > 0) {
output += "\n\n    <div class=\"o-row c-ugc-filters\">\n\n        <ul class=\"c-ugc-filters__ul\" data-qa-ugc-filter=";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "filter")),"displayText"), env.opts.autoescape);
output += ">\n\n            <li class=\"c-ugc-filters__li\" data-filter-index=\"-1\">\n\n                <a href=\"\"\n                    class=\"c-ugc-filters__a js-ugc-filter\"\n                    ";
output += runtime.suppressValue((lineno = 13, colno = 23, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["PAGE_TYPE","ugc filter","view all"])), env.opts.autoescape);
output += ">\n                    ";
output += runtime.suppressValue((lineno = 14, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["ugc_view-all"])), env.opts.autoescape);
output += "\n                </a>\n\n            </li>\n\n            ";
frame = frame.push();
var t_5 = runtime.contextOrFrameLookup(context, frame, "filters");
if(t_5) {var t_4 = t_5.length;
for(var t_3=0; t_3 < t_5.length; t_3++) {
var t_6 = t_5[t_3];
frame.set("filter", t_6);
frame.set("loop.index", t_3 + 1);
frame.set("loop.index0", t_3);
frame.set("loop.revindex", t_4 - t_3);
frame.set("loop.revindex0", t_4 - t_3 - 1);
frame.set("loop.first", t_3 === 0);
frame.set("loop.last", t_3 === t_4 - 1);
frame.set("loop.length", t_4);
output += "\n\n                ";
var t_7;
t_7 = ((runtime.memberLookup((t_6),"filterValue") == runtime.contextOrFrameLookup(context, frame, "activeFilter"))?"is-active":"");
frame.set("activeClass", t_7, true);
if(frame.topLevel) {
context.setVariable("activeClass", t_7);
}
if(frame.topLevel) {
context.addExport("activeClass", t_7);
}
output += "\n\n                <li class=\"c-ugc-filters__li ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "activeClass"), env.opts.autoescape);
output += "\" data-filter-index=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"), env.opts.autoescape);
output += "\">\n\n                    <a href=\"\"\n                        class=\"c-ugc-filters__a js-ugc-filter\"\n                        ";
output += runtime.suppressValue((lineno = 27, colno = 27, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["PAGE_TYPE","ugc filter",runtime.memberLookup((t_6),"displayText")])), env.opts.autoescape);
output += ">\n                        ";
output += runtime.suppressValue(runtime.memberLookup((t_6),"displayText"), env.opts.autoescape);
output += "\n                    </a>\n\n                </li>\n\n            ";
;
}
}
frame = frame.pop();
output += "\n\n        </ul>\n\n    </div>\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/ugc-filters.j2"] , dependencies)